export const parseRelatedRecordRows = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value !== 'string') return [];

  try {
    const rows = JSON.parse(value);
    return Array.isArray(rows) ? rows : [];
  } catch {
    return [];
  }
};

export const getActiveWarrantCount = (rows) =>
  parseRelatedRecordRows(rows).filter((row) => row?.Disposition.toLowerCase() === 'active').length;
